var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 7.5835C9.08301 7.5835 8.33301 8.3335 8.33301 9.25016C8.33301 10.1668 9.08301 10.9168 9.99967 10.9168C10.9163 10.9168 11.6663 10.1668 11.6663 9.25016",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.9165V13.4165",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1585 6.4333C17.1585 5.4083 16.3751 4.27497 15.4168 3.91663L11.2585 2.3583C10.5668 2.09997 9.43346 2.09997 8.7418 2.3583L4.58346 3.92497C3.62513 4.2833 2.8418 5.41663 2.8418 6.4333V12.625C2.8418 13.6083 3.4918 14.9 4.28346 15.4916L7.8668 18.1666C9.0418 19.05 10.9751 19.05 12.1501 18.1666L15.7335 15.4916C16.5251 14.9 17.1751 13.6083 17.1751 12.625V9.69163",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/securityIcon.685a1e66fe0f34fb6aad0f3740babc80.svg";
export { ForwardRef as ReactComponent };